// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/ImageCommentPin.test.tsx
import { type BaseTicketComment } from "@mg/schemas/src/christo/catalyst";
import { createContext } from "react";

/**
 * Which side of a version comparison a numbered pin stands for: the older
 * version's (a gold ring, what was there) or the newer version's (a solid navy
 * pin, what came); or, outside a comparison, how much a finding weighs:
 * `strong` for one to fix before print, `soft` for a minor or check one;
 * `draft` while the review is still running and its findings may yet merge.
 */
export type PinTone = "before" | "after" | "strong" | "soft" | "draft";

/**
 * The tone of a pin, or null for an ordinary one.
 *
 * Set only by the Ask v2 review: the comparison draws its changed windows as
 * pins on both versions, and the review tones each finding by its severity.
 * With no provider every pin renders as it always has.
 *
 * why a context and not a prop: as `RejectedPinLabelContext` says, the pins
 * render inside the viewers nested in `AssetViewerPane`, and a prop would
 * thread through each of them for a v2-only look.
 */
export const PinToneContext = createContext<
  ((comment: BaseTicketComment) => PinTone | null) | null
>(null);
